import { AppContext } from "../AppContext";
import http from "../Services/http-common";
const LoginDataService = {
  Login: async function (data) {
    return await http
      .post("/auth/login", {
        email: data.email, password: data.password,
        mFApasswordPolicyAccessToken: data.provider_Access_Token, passwordPolicy: data.passwordPolicyChange,
        MFAEnabled: data.MFAEnabled
      })
      .then((response) => {
        localStorage.setItem("JWtToken", response.data.jwt);
        if (response.status == 502) {
          return "Server maintenance";
        } else {
          return response;
        }
      })
      .catch((error) => {
        console.log(error.message);
        return error;
      });
  },
  APILogin: async function (ekey) {
    return await http
      .post("/auth/apilogin", { ekey: ekey })
      .then((response) => {
        //
        localStorage.setItem("JWtToken", response.data.jwt);
        return response;
      })
      .catch((error) => {
        console.log(error.message);
        return error.response;
      });
  },
  CacheData: async function (keyRDocsDocumentDetails) {
    return await http
      .post("/GetCacheData", { key: keyRDocsDocumentDetails.key })
      .then((response) => {
        localStorage.setItem("JWtToken", response.data.jwt);
        if (response.status == 502) {
          return "Server maintenance";
        } else {
          return response;
        }
      })
      .catch((error) => {
        console.log(error.message);
        return error.response;
      });
  },
  SSOLogin: async function (ssoTokenRequestModel) {
    return await http
      .post("/auth/ssologin", ssoTokenRequestModel)
      .then((response) => {
        localStorage.setItem("JWtToken", response.data.jwt);
        return response;
      })
      .catch((error) => {
        console.log(error.message);
        return error.response;
      });
  },

  MFAPasswordPolicy: async function (appDetails) {
    try {
      const response = await http.post(
        AppContext.RCapMFAandPasswordUrl +"/Login/Setting",
        {
          emailAddress: appDetails.email,
          client_Id: appDetails.clientId,
          browser_Device: appDetails.browserDevice,
          infoExist: true,
        }
      );
      console.log(response);
      const data = response.data;
      return {
        mfaEnabled: data?.resultContent?.mfaEnabled ?? false,
        enforcePasswordPolicy: data?.resultContent?.enforcePasswordPolicy ?? 0,
        passwordChange: data?.resultContent?.passwordChange ?? 0,
        success: data?.success ?? true,
      };

    } catch (error) {     
      return error;
    }
  },

  MFALogin: async (data) => {
    try {
      const response = await http.post(
        AppContext.RCapMFAandPasswordUrl +"/MFA/Token",
        {
          emailAddress: data.email,
          password: data.password,
          client_Id: AppContext.ClientId,
        }
      );
      if (response.data) {
        return {
          mfaToken: response.data.resultContent.mfA_Token,
          language: response.data.resultContent.userLanguage,
        };
      }
    } catch (error) {
      return error;
    }
  },
};
export default LoginDataService;
